import { useAssetComponents } from "@/hooks/useAssetComponents";
import { cn } from "@/lib/utils";
import { useCanvasStore } from "@/components/Canvas/stores/canvasStore";
import { ChevronRight, ComponentIcon, HomeIcon } from "lucide-react";
import { Button } from "../ui/button";

const SubcanvasHeader = () => {
  const canvasComponentKey = useCanvasStore(
    (store) => store.canvasComponentKey,
  );
  const setCanvasComponentKey = useCanvasStore(
    (store) => store.setCanvasComponentKey,
  );
  const { componentKeyToComponent } = useAssetComponents();

  return (
    <div className="w-full flex flex-col">
      <div
        className={cn(
          "w-full flex justify-between items-center p-3 border-b pointer-events-auto bg-secondary-200",
        )}
      >
        <div className="flex gap-2 items-center justify-start">
          <Button
            variant="secondary"
            size="sm"
            className="h-8 hover:bg-secondary-500 flex gap-1 text-secondary-900 hover:text-white"
            onClick={() => {
              // @ts-expect-error TS2345
              setCanvasComponentKey(null);
            }}
          >
            <HomeIcon className="h-3 w-3" />
            Home
          </Button>
          <ChevronRight className="w-4 h-4 text-secondary-900" />
          <Button
            variant="secondary"
            size="sm"
            className="h-8 text-primary-400 flex gap-1 cursor-default"
          >
            <ComponentIcon className="stroke-primary-400 h-3 w-3" />
            {/*
                   // @ts-expect-error TS2538 */}
            {componentKeyToComponent?.[canvasComponentKey]?.componentName}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SubcanvasHeader;
